import { render, staticRenderFns } from "./SmsDetailIncomingInfo.vue?vue&type=template&id=365621b8&"
import script from "./SmsDetailIncomingInfo.vue?vue&type=script&lang=ts&"
export * from "./SmsDetailIncomingInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports